Ext.define('SA.SessionController', {
    constructor() {
        this.state = new SA.SessionState();
        this.state.on('dirty', this.onStateDirty, this);
        this.state.on('expired', this.onStateExpired, this);
        this.state.on('replaced', this.onStateReplaced, this);

        this.pingTask = new SA.SessionPingTask(this.setExpired.bind(this));
        this.browserTab = new SA.BrowserTab(this.setReplaced.bind(this));
        this.activityInterval = new SA.Interval(() => this.refreshLastActive(), 2000);
    },

    cancelActivityInterval() {
        this.activityInterval.cancel();
    },

    createPopup(xtype, cfg = {}) {
        Ext.widget({xtype, ...cfg});
    },

    disableErrorStack() {
        SA.ErrorStack.disable();
    },

    onAjaxSessionError(error) {
        error.isSessionExpiredError() ? this.setExpired() : this.setDirty();
    },

    onStateDirty() {
        SA.Ajax.request({method: 'acknowledge', resource: 'dirtySession'});

        this.disableErrorStack();
        this.cancelActivityInterval();
        this.createPopup('session-dirty-popup', {handler: () => location.reload()});
    },

    onStateExpired() {
        this.onStateReplacedOrExpired();
        this.createPopup('session-expired-popup');
    },

    onStateReplaced() {
        this.onStateReplacedOrExpired();
        this.createPopup('session-replaced-popup');
    },

    onStateReplacedOrExpired() {
        SA.Ajax.disable();

        this.pingTask.cancel();
        this.browserTab.cancelReplacedListener();

        this.disableErrorStack();
        this.cancelActivityInterval();
    },

    refreshLastActive() {
        SA.LocalStorage.set('lastActive', Date.now()); 
    },

    replacedOrExpired() {
        return this.state.replacedOrExpired();
    },

    setDirty() {
        this.state.setDirty();
    },

    setExpired() {
        this.state.setExpired();
    },

    setReplaced() {
        this.state.setReplaced();
    }
});